module.exports = __webpack_public_path__ + "static/media/FriendFinder01.50aaf443.png";